import { getRuntime } from "./index.js";
export function isStrictMode(runtimeContext) {
  var _ref, _getRuntime;
  return !!((_ref = runtimeContext ? runtimeContext.flags : (_getRuntime = getRuntime()) === null || _getRuntime === void 0 ? void 0 : _getRuntime.getFeatureFlags()) !== null && _ref !== void 0 && _ref["brick-next-v3-strict-mode"]);
}
export function warnAboutStrictMode(strict, message) {
  for (var _len = arguments.length, extraLogs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    extraLogs[_key - 2] = arguments[_key];
  }
  const punctuation = extraLogs.length === 0 ? "" : ",";
  if (strict) {
    // eslint-disable-next-line no-console
    console.error(`${message} is dropped in v3 strict mode${punctuation}`, ...extraLogs);
  } else {
    // eslint-disable-next-line no-console
    console.warn(`${message} is deprecated in v3 and will be dropped in strict mode${punctuation}`, ...extraLogs);
  }
}
//# sourceMappingURL=isStrictMode.js.map